/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from '@reduxjs/toolkit'
import axiosBase from '../../services/axios-base'
import { getInforUserAPI, loginAPI } from '../actions/userActions'

export type CartItem = {
  quantity: number
  _id: string
  productId: string
  name: string
  productImg: string
  price: number
}

export type UserInformations = {
  _id: string
  role: number
  username: string,
  email: string,
  phone: string,
  company: string,
  country: string,
  address: string,
  cartItems: CartItem[]
}

export type AuthStates = {
  user: null | UserInformations
  isAuthenticated: boolean
  cartItems?: Array<CartItem>
  err?: {
    success: boolean
    message: string
  } | null
}

const initialState: AuthStates = {
  user: null,
  isAuthenticated: false,
  err: null,
}

export interface AuthResponseType {
  success: boolean
  accessToken: string
  refreshToken: string
}

export const authSlices = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // getAllProducts: async () => {
    //   const data = await fetchProducts()
    // },

  },
  extraReducers: (builders) => {
    builders
      .addCase(loginAPI.fulfilled, (state, action) => {
        localStorage.setItem('token', action.payload.accessToken)
        axiosBase.setToken(action.payload.accessToken)
        state.isAuthenticated = action.payload.success
        state.err = null
        window.location.href = '/'
      })
      .addCase(getInforUserAPI.fulfilled, (state, action) => {
        state.isAuthenticated = action.payload.success
        state.user = action.payload.user
        // window.location.href = '/'
      })
      .addCase(getInforUserAPI.rejected, (state) => {
        state.isAuthenticated = false
        state.user = null
      })
    // .addCase(removeFromCartAPI.rejected, (state, action) => {
    //   state.err = action.payload?.message as string
    // })
  }
})

export default authSlices.reducer
